import Web3 from 'web3'
import WalletConnectProvider from "@walletconnect/web3-provider"
import Web3Modal from "web3modal";

const getWeb3ByWalletConnect = () =>
  new Promise(async (resolve, reject) => {
    const networkId = process.env.REACT_APP_NETWORK_ID
    if (networkId === "97" || networkId === "56") {
      const providerOptions = {
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            rpc: {
              56: 'https://bsc-dataseed.binance.org/', 97: "https://data-seed-prebsc-2-s1.binance.org:8545",
            },
            network: 'binance',
            chainId: networkId,
          },
        },
      };
      const web3Modal = new Web3Modal({
        cacheProvider: false,
        disableInjectedProvider: true,
        providerOptions: providerOptions,
      });
      try {
        const provider = await web3Modal.connect();
        const web3 = new Web3(provider)
        provider.on('accountsChanged', (accounts) => {
          window.location.reload()
        })

        provider.on('chainChanged', (chainId) => {
          window.location.reload()
        })
        provider.on("disconnect", (code, reason) => {
          window.location.reload()
        });

        resolve(web3)
      } catch (error) {
        console.log(error)
        reject(error)
      }
    }
  })

export default getWeb3ByWalletConnect
